import styles from "../styles/widget.module.css"

interface Props {
  chips: string[]
  onPick: (chip: string) => void
}

export function Chips({ chips, onPick }: Props) {
  if (!chips.length) return null
  return (
    <div className={styles.chips}>
      {chips.map((c) => (
        <button
          key={c}
          type="button"
          className={styles.chip}
          onClick={() => onPick(c)}
        >
          {c}
        </button>
      ))}
    </div>
  )
}
